import * as React from "react"

export * from "framer-motion"

export {
    Scroll,
    ScrollProps,
    ScrollEvents,
    ScrollConfig,
    Page,
    PageEvents,
    PageProps,
    PageProperties,
    PageEffect,
    PageEffectInfo,
    PageAlignment,
    Draggable,
    Stack,
    StackProperties,
    StackSpecificProps,
    Navigation,
    calcChildLayoutRects,
} from "./components"
export { WithNavigator } from "./components/hoc/WithNavigator"
export {
    Device,
    DeviceProperties,
    DeviceDescriptor,
    DeviceSkin,
    DeviceSkins,
    DeviceRenderer,
} from "./components/devices/Device"
export * from "./components/devices/Devices"

export { AnyInterpolation, ValueInterpolation } from "./interpolation"

export { Animatable, AnimatableObject, Cancel } from "./animation/Animatable"
export { animate } from "./animation/animate"
export { FramerAnimation } from "./animation/FramerAnimation"
export { BezierAnimator, SpringAnimator } from "./animation/Animators"

export { FramerEvent, FramerEventListener, FramerEventSession } from "./events"

export { NavigationTransitionOptions } from "./components/NavigationTransitions"

export {
    Point,
    Size,
    Rect,
    Vector,
    VectorGroup,
    ComponentContainer,
    ComponentIdentifier,
    SVG,
    Text,
    Frame,
    FrameProps,
    BaseFrameProps,
    FrameLayoutProperties,
    CSSTransformProperties,
    VisualProperties,
    DeprecatedFrame,
    QualityOptions,
    DeprecatedFrameProperties,
    DeprecatedFrameWithEvents,
    DeprecatedFrameWithEventsProps,
    componentLoader,
    setGlobalRenderEnvironment,
    RenderTarget,
    ControlType,
    PropertyControls,
    ArrayControlDescription,
    ControlDescription,
    updateComponentLoader,
    getConfigFromPreviewURL as getConfigFromURL,
    getConfigFromPreviewURL,
    getConfigFromVekterURL,
    serverURL,
    NavigationLink,
    isReactDefinition,
    createDesignComponent,
    CanvasStore,
    isOverride,
    Color,
    ConvertColor,
    ColorMixModelType,
    addServerUrlToResourceProps,
    BackgroundProperties,
    CustomProperties,
    CustomPropertiesContext,
    constraintsEnabled,
} from "./render"

export { ObservableObject } from "./data/ObservableObject"
export { Data } from "./data/Data"
export { Override, OverrideFunction, OverrideObject, WithOverride } from "./data/WithOverride"
export { DataObserver } from "./data/DataObserver"
export { PropertyStore } from "./data/PropertyStore"

export { loadJSON } from "./utils/network"
export { print } from "./utils/print"
export { addPropertyControls, getPropertyControls } from "./utils/addPropertyControls"
export { version } from "./version"

import { MainLoop } from "./core/Loop"
export { MainLoop }

// Only start the loop if this is the library
if (process.env.BUILD_NAME === "framer") {
    MainLoop.start()
}
